import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MemberHeader from '../../components/member-header';
import { replace } from '../../services/router-utils';
import { getMembersCount } from '../../selectors/member-selectors';
import withAuth from '../../hoc/with-auth';

class MembersMenu extends Component {
  handleSortChange = sort => {
    const { name } = this.props;
    this.props.onFilterChange({ sort, name });
  };

  handleFilterChange = name => {
    const { sort } = this.props;
    this.props.onFilterChange({ sort, name });
  };

  render = () => {
    const { sort, name, membersCount, isBlocked } = this.props;
    if (isBlocked) {
      return null;
    }
    return (
      <MemberHeader
        sort={sort}
        onSortChange={this.handleSortChange}
        filter={name}
        onFilterChange={this.handleFilterChange}
        membersCount={membersCount}
      />
    );
  };
}

MembersMenu.propTypes = {
  onFilterChange: PropTypes.func,
  sort: PropTypes.string,
  name: PropTypes.string,
  membersCount: PropTypes.number,
  isBlocked: PropTypes.bool,
};

const buildLocation = (location, params) => ({ ...location, query: { ...params } });

const mapStateToProps = (state, { location }) => ({
  sort: location.query.sort || 'postsCount',
  name: location.query.name || '',
  membersCount: getMembersCount(state),
});

const mapDispatchToProps = (dispatch, { location }) =>
  bindActionCreators(
    {
      onFilterChange: params => replace(buildLocation(location, params)),
    },
    dispatch
  );

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps), withAuth)(MembersMenu);



// WEBPACK FOOTER //
// ./app/containers/members-menu/members-menu.js